// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--+ZePN";
export var Logo = "Footer-module--Logo--sXcM6";
export var FooterNav = "Footer-module--FooterNav--48TMe";
export var FooterBottom = "Footer-module--FooterBottom--3hUdr";
export var FooterButton = "Footer-module--FooterButton--J5GJs";